<template>
  <vgloballayout :loading="loading" :error="error" @reload="onLoadInfo">
    <div slot="body">
      <h1>Редактирование новости</h1>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="Заголовок" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="Ссылка на источник">
          <el-input v-model="ruleForm.url"></el-input>
        </el-form-item>

        <el-form-item prop="text" class="form-html">
          <textarea
            id="editornew"
            multiple=""
            ref="editornew"
            name="editor"
          ></textarea>
        </el-form-item>
        <div class="line-border"></div>
        <div class="Small Title m-b-20">Список прикрепленных файлов</div>
        <div>
          <addFileNew
            ref="fileListLoad"
            :fileList="fileList"
            @addFile="addFile"
            @removeNewFile="removeNewFile"
            @deleteCheck="deleteCheck"
          />
        </div>
        <div class="line-border"></div>

        <el-form-item class="m-t-25">
          <el-button @click="resetForm()">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="loadingSub"
            >Сохранить</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </vgloballayout>
</template>

<script>
import { BASE_URL, BASE_DOC_URL } from "@/plugins/url-env";
import addFileNew from "./addFileToNews";

export default {
  data() {
    return {
      loading: false,
      deleteCheckboxes: [],
      loadingSub: false,
      error: false,
      fileList: {
        files: []
      },
      ruleForm: {
        title: "",
        url: "",
        shortText: "",
        text: "",
        files: []
      },
      editor: null,
      url: BASE_URL + "/organization/LocalStorage/Upload",
      rules: {
        shortText: [
          {
            required: true,
            message: "Поле не должно быть пустым",
            trigger: "blur"
          },
          {
            min: 0,
            max: 1000,
            message: "Максимум 1000 символов",
            trigger: "blur"
          }
        ],
        text: [
          {
            required: true,
            message: "Поле не должно быть пустым",
            trigger: "blur"
          },
          {
            min: 0,
            max: 100000,
            message: "Максимум 100000 символов",
            trigger: "blur"
          }
        ],
        title: [
          {
            required: true,
            message: "Поле не должно быть пустым",
            trigger: "blur"
          },
          {
            min: 0,
            max: 100,
            message: "Максимум 100 символов",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.onLoadInfo();
  },
  methods: {
    deleteCheck(val) {
      this.deleteCheckboxes = val;
    },
    addFile(data) {
      let img = new Image();
      img.src = URL.createObjectURL(data.file.raw);
      data.file.image = img;

      this.fileList.files.push({
        title: data.title,
        file: data.file,
        id: data.id
      });
    },
    removeNewFile(index) {
      this.fileList.files.splice(index, 1);
    },

    async initializationEditor() {
      setTimeout(() => {
        let editor = new Jodit(this.$refs.editornew, {
          uploader: {
            url: BASE_URL + "/LocalStorage/Upload",
            format: "json",
            filesVariableName: "File",
            pathVariableName: "File",
            withCredentials: true,
            prepareData: function(data) {
              data.append("file", data.get("files[0]"));
              data.delete("files[0]");
              data.delete("path");
              data.delete("source");
            },
            isSuccess: function(resp) {
              if (window.getSelection) {
                var elem = document.createElement("img");
                elem.setAttribute("id", "editorImage");
                const src = `${BASE_URL}/${resp.file}`;
                elem.src = src;
                var wall = window.getSelection().focusNode.parentNode.firstChild
                  .parentNode;
                //проверяем где расположена каретка. Если вне редактора тогда вставляем картинку начало
                if (
                  window
                    .getSelection()
                    .focusNode.parentNode.firstChild.parentNode.closest(
                      ".jodit_wysiwyg"
                    ) !== null
                ) {
                  var first = wall.childNodes[0];
                  wall.insertBefore(elem, first);
                } else {
                  editor.value = `<img src="${src}" />` + editor.value;
                }
              } else if (document.selection && document.selection.createRange) {
                document.selection.createRange().text = respImg;
              }

              return !resp.error;
            },
            getMsg: function(resp) {
              return resp.msg.join !== undefined
                ? resp.msg.join(" ")
                : resp.msg;
            },
            process: function(resp) {
              return {
                baseurl: resp.baseurl,
                error: resp.error,
                msg: resp.msg
              };
            },
            error: function(e) {
              this.$notify.error({
                title: "Произошла ошибка",
                message: `Что-то пошло не так, обратитесь в техподдержку`,
                offset: 0
              });
            },
            defaultHandlerSuccess: function(data, resp) {
              var i,
                field = "files";
              if (data[field] && data[field].length) {
                for (i = 0; i < data[field].length; i += 1) {
                  this.selection.insertImage(data.baseurl + data[field][i]);
                }
              }
            },

            defaultHandlerError: function(resp) {
              console.log("err => ", resp);
            }
          },
          language: "ru",
          minHeight: 400,
          editSrc: true,
          showPreview: true
        });
        editor.value = this.ruleForm.text;

        editor.events.on("change", data => {
          this.ruleForm.text = data;
        });

        // Сохраняем editor в стейт, чтобы добавить проверку в submit формы
        this.editor = editor
      }, 400);
    },

    /*         async documentEditTitle(data) {
            if(data.guid) {
                try {
                    await this.$store.dispatch('documentEditTitle', data)
                    this.$message({
                        message: 'Файл успешно переименован',
                        type: 'success'
                    });
                } catch(e) {
                    this.$ErrorsMod(e)
                }
            }
        }, */

    async onLoadInfo() {
      this.loading = true;
      this.error = false;

      try {
        let query = await this.$store.dispatch("newsDetail", {
          id: this.$route.params.id
        });

        for (let key in query) {
          this.ruleForm[key] = query[key];
        }

        for (let item of query.documents) {
          this.fileList.files.push({
            id: item.id,
            title: item.title,
            fileName: item.fileName,
            type: item.extension.replace(".", ""),
            file: {
              image: {
                currentSrc: `${BASE_URL}/document/${item.fileName}`
              }
            }
          });
        }
        this.initializationEditor();
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }

      this.loading = false;
    },
    async submitForm() {
      let validateFileList = await this.$refs.fileListLoad.validateFilesName();

      this.$refs.ruleForm.validate(async valid => {
        if (valid && validateFileList) {
          const loading = this.$loading({
            lock: true,
            text: "Подождите",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          try {
            if (this.fileList.files.length) {
              for (let item of this.fileList.files) {
                if (item.file.size > 0) {
                  let data = new FormData();
                  data.append("IsAttachment", true);
                  data.append("file", item.file.raw);
                  data.append("title", item.title);

                  let query = await this.$store.dispatch(
                    "documentUploadFile",
                    data
                  );
                  this.ruleForm.files.push(query.fileName);
                }
              }
            }

            if (this.deleteCheckboxes.length > 0) {
              await this.$store.dispatch(
                "documentDeleteFiles",
                this.deleteCheckboxes
              );
            }

            // Если текст в стейте ruleForm не такой же, как в editor, перезаписываем его
            if (this.ruleForm.text !== this.editor.value) {
              this.ruleForm.text = this.editor.value;
            }

            await this.$store.dispatch("newsEdit", this.ruleForm);
            this.$message({
              message: "Новость обновлена",
              type: "success"
            });
            /*                         setTimeout(() => {
                            location.reload(true)
                        }, 500); */
          } catch (e) {
            this.$ErrorsMod(e);
          }

          loading.close();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$router.push({ path: "/news/" });
    }
  },
  components: {
    addFileNew
  }
};
</script>

<style>
.form-html .el-form-item__content {
  line-height: 20px !important;
}
.downloadFile {
  color: #409eff;
  font-size: 12px;
  text-decoration: none;
}
span.downloadFile {
  color: #f56c6c;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
}
.el-upload-list_block {
  position: absolute;
  position: absolute;
  text-align: center;
  width: 100%;
  background: rgba(255, 255, 255, 0.72);
  height: 100%;
}

.el-upload-list_block span {
  cursor: pointer;
  color: #107ef7;
}
</style>
